import React, { useEffect, useState } from "react";
import Select from "react-select";

const CustomDropdown = ({
  allCountryCodes,
  formData,
  setFormData,
  fieldHeight = "38px",
}) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "0",
      borderBottom: "1px solid #aca9a5",
      borderRadius: "0",
      boxShadow: "none",
      height: fieldHeight,
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      padding: "10px",
      backgroundColor: state.isSelected ? "#f5f5f5" : "white",
      color: "black",
      "&:hover": {
        backgroundColor: "#e9e9e9",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const [isLoadingLocation, setIsLoadingLocation] = useState(true);

  const [ip, setIP] = useState("");


  const options = allCountryCodes.map((country) => ({
    value: country.dialCode,
    label: (
      <div className="flex items-center min-w-20">
        <img
          src={country.flag}
          alt={country.name || country.code} // Use country name or code for alt
          style={{ width: "15px", height: "15px", marginRight: "10px" }}
        />
        <span className="text-[12px] leading-none font-medium text-[#74716d]">{`${country.dialCode}`}</span>
      </div>
    ),
    countryCodeISO: country.code, // Store the ISO code (e.g., "US", "GB") for matching
  }));

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIP(data.ip))
      .catch((err) => console.error("Failed to fetch IP:", err));
  },[formData.countryCode, ip, options]);

  useEffect(() => {
    const fetchUserCountry = async () => {
      if (!allCountryCodes || allCountryCodes.length === 0) {
        console.warn("allCountryCodes is empty, cannot auto-select country.");
        setIsLoadingLocation(false);
        return;
      }

      try {
        const response = await fetch(
          `http://ip-api.com/json/${ip}?fields=status,message,countryCode`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        if (data.status === "success" && data.countryCode) {
          const userCountryISO = data.countryCode; // e.g., "US"

          const matchedOption = options.find(
            (option) => option.countryCodeISO === userCountryISO
          );

          if (matchedOption) {
            setFormData((prevFormData) => ({
              ...prevFormData,
              countryCode: matchedOption.value,
            }));
          } else {
            console.warn(
              `No matching country found for ISO code: ${userCountryISO}`
            );
          }
        } else if (data.status === "fail") {
          console.error(
            "Failed to fetch user country (API error):",
            data.message
          );
        }
      } catch (error) {
        console.error(
          "Failed to fetch user country (network/request error):",
          error
        );
      } finally {
        setIsLoadingLocation(false);
      }
    };

    if (!formData.countryCode) {
      fetchUserCountry();
    } else {
      setIsLoadingLocation(false);
    }
  }, [allCountryCodes, setFormData, ip, formData.countryCode, options]);

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setFormData({ ...formData, countryCode: selectedOption.value });
    } else {
      setFormData({ ...formData, countryCode: null });
    }
  };

  const selectedValue = options.find(
    (opt) => opt.value === formData.countryCode
  );

  if (
    isLoadingLocation &&
    !formData.countryCode &&
    allCountryCodes &&
    allCountryCodes.length > 0
  ) {
    return (
      <div className="h-[40px] flex items-center text-[#74716d]">
        Loading country...
      </div>
    );
  }

  return (
    <Select
      options={options}
      styles={customStyles}
      className={`w-full`}
      value={selectedValue}
      onChange={handleChange}
      isClearable
      placeholder="Country Code"
    />
  );
};

export default CustomDropdown;
